// list of ear-frequencies in order that they will be tested
// each element determines the set of audio files to load for the test screens
const freqList = [
  'R1000',
  'R500',
  'R2000',
  'R3000',
  'R4000',
  'R8000',
  'L1000',
  'L500',
  'L2000',
  'L3000',
  'L4000',
  'L8000',
];

// if 3 misses above 80 are recorded at any of these frequencies, retest that point
const lowFreqList = ['R500', 'L500', 'R1000', 'L1000', 'R2000', 'L2000'];

// check for asymmetries after any of these measurements
// note that the left ear is tested after the right
const asymFreqList = ['L500', 'L1000', 'L2000'];

// DEV
// const freqList = ['R1000', 'R500']

// random time interval between successive stimuli during test sequence
// uniform interval defined by these parameters (ms)

// dev values
// const intervalLower = 50;
// const intervalUpper = 100;

// production values
const intervalLower = 2000;
const intervalUpper = 4000;

// if user response occurs within this many ms after stimulus start, do not count it as a Hit
const falseAlarmThreshold = 150;

// if user has a Hit at <=5 dB this many times, call 5 dB their threshold
const numHits5Threshold = 2;
// if user has a miss at 85 dB this many times, call 85 their threshold
const numMisses85Threshold = 2;

// maximum number of trials in a sequence before best guess is made at threshold
const maxTrials = 20;

// Local "hearing test only" mode: runs test logic without posting to external APIs
const localHearingOnly =
  process.env.REACT_APP_LOCAL_HEARING_ONLY === 'true';

// Environment variables - must be set in Google Cloud Build
// For Create React App, variables must be prefixed with REACT_APP_
// Set via Google Cloud Secret Manager or substitution variables
const hmacSecret = process.env.REACT_APP_HMAC_SECRET || '';
if (!hmacSecret && !localHearingOnly) {
  throw new Error('REACT_APP_HMAC_SECRET environment variable is required');
}

// audicus api requests go through this link
// Set via Google Cloud Secret Manager or substitution variables
// Preview branches: dev API URL
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || '';
if (!apiBaseUrl && !localHearingOnly) {
  throw new Error('REACT_APP_API_BASE_URL environment variable is required');
}

const constants = {
  freqList: freqList,
  intervalLower: intervalLower,
  intervalUpper: intervalUpper,
  falseAlarmThreshold: falseAlarmThreshold,
  numHits5Threshold: numHits5Threshold,
  numMisses85Threshold: numMisses85Threshold,
  maxTrials: maxTrials,
  apiBaseUrl: apiBaseUrl,
  hmacSecret: hmacSecret,
  lowFreqList: lowFreqList,
  asymFreqList: asymFreqList,
  localHearingOnly,
};

export default constants;
